if (typeof $ == 'undefined') {
  //load jquery from cdn then excecute collectionTabsJS
  var script = document.createElement('script');
  script.src = "https://code.jquery.com/jquery-3.4.1.min.js";
  script.onload = function () {
    globalJS();
  };
  document.head.appendChild(script);
} else {
  globalJS();
}
function globalJS() {
  // Track recently viewed products
  trackRecentlyViewed();

  //Apply Discount code
  $(".cartDiscountSubmit").on("click", discountSubmitHandle);

  //Remove Discount code
  $(".remove-discount").on("click", discountRemoveHandle);

  //Hide discount error when user types
  $(".cartDiscountInput").on("input", function () {
    $(".cartDiscountError").remove();
  });

  //Smmooth scroll link
  $(".linkSmoothScroll").on("click", function (e) {
    e.preventDefault();
    let target = $(this).attr("href");
    $("html, body").animate({ scrollTop: $(target).offset().top }, 1000);
  });

  //Review star click
  $(".card-information .rating,.card-information .rating-count.caption").on("click", function () {
    if ($(".testimonials-slider-wrapper").length) {
      $("html, body").animate({ scrollTop: $(".testimonials-slider-wrapper").offset().top }, 1000);
    }
  });

  //Menu dropdown
  $(".header_main-menu>li").on("mouseenter", function () {
    let theDetailds = $(this).find("details");
    theDetailds.attr('open', true);
  }).on("mouseleave", function () {
    let theDetailds = $(this).find("details");
    theDetailds.removeAttr('open');
  });

  //Desktop navigation click behavior - navigate to top-level category on click
  $(document).on("click", "summary[data-desktop-link] span", function (e) {
    // Only on desktop (screen width >= 990px)
    if (window.innerWidth >= 990) {
      e.stopImmediatePropagation();
      e.preventDefault();
      const linkUrl = $(this).closest('summary').data('desktop-link');
      if (linkUrl) {
        window.location.href = linkUrl;
      }
      return false;
    }
  });

  // Menu drawer
  $(".menu-drawer__menu>li>a.drawerHasChild").on("click", function (e) {
    e.preventDefault();
    $(".menu-drawer__menu>li>a").removeClass("active");
    $(this).addClass("active");
    let thisIndex = $(this).data("index");
    $(".menuSecondLevel").removeClass("active");
    $(".menuSecondLevel[data-index='" + thisIndex + "']").addClass("active");
  });

  //Announcement Bar
  $(".annoucementBarClose").on("click", function () {
    $(".announcement-bar-section").slideToggle("fast");
    $("body").append('<style>.shopify-section-header-sticky:not(.shopify-section-header-hidden) { top: 0px; }</style>');
  });

  // Product card color swatches
  initProductCardSwatches();

  // Also initialize when DOM is fully loaded (for collection pages)
  if (document && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductCardSwatches();
    });
  }

  // Newsletter popup trigger - Track clicks on #newsletterpopup links
  $(document).on("click", 'a[href="#newsletterpopup"]', function (e) {
    e.preventDefault();
    if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
      window._klOnsite.openForm("SUUFk4");
    } else {
      console.warn('Klaviyo form could not be opened - _klOnsite not available');
    }
  });

  // Collection sale tag click handler - open sale modal (same as home page)
  $(document).on("click", ".collection-hero__sale-tag", function (e) {
    e.stopPropagation();
    e.preventDefault();
    
    // Find the banner modal using the same pattern as home page
    const saleModal = document.querySelector('modal-dialog[id^="BannerModal-"]');
    
    if (saleModal && typeof saleModal.show === 'function') {
      // Call show with the clicked element, same as home page: modal.show(event.target)
      saleModal.show(e.target);
    }
    
    return false;
  });

  // Product page sale tag click handler - open sale modal
  $(document).on("click", ".product__sale-tag", function (e) {
    e.stopPropagation();
    e.preventDefault();
    
    const saleModal = document.querySelector('modal-dialog[id^="BannerModal-"]');
    if (saleModal && typeof saleModal.show === 'function') {
      saleModal.show(e.target);
    }
    
    return false;
  });
  
  // Intercept clicks on modal-opener to check if sale tag was clicked (backup method)
  setTimeout(function() {
    const modalOpeners = document.querySelectorAll('.product__modal-opener');
    modalOpeners.forEach(function(modalOpener) {
      modalOpener.addEventListener('click', function(e) {
        const container = modalOpener.closest('.product-media-container');
        if (!container) return;
        
        const saleTag = container.querySelector('.product__sale-tag');
        if (saleTag) {
          const saleTagRect = saleTag.getBoundingClientRect();
          
          // Check if click coordinates are within sale tag bounds
          const clickInSaleTag = (
            e.clientX >= saleTagRect.left &&
            e.clientX <= saleTagRect.right &&
            e.clientY >= saleTagRect.top &&
            e.clientY <= saleTagRect.bottom
          );
          
          if (clickInSaleTag) {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            
            const saleModal = document.querySelector('modal-dialog[id^="BannerModal-"]');
            if (saleModal && typeof saleModal.show === 'function') {
              saleModal.show(saleTag);
              return false;
            }
          }
        }
      }, true); // Capture phase - intercept before modal-opener's handler
    });
  }, 1000);
}

function initProductCardSwatches() {
  // Color mapping (matching product-media-gallery.liquid logic)
  const colorMapping = {
    'Sandstone': '-SND-',
    'Black': '-BLK-',
    'Pink': '-PNK-',
    'Royal Blue': '-royalblue-',
    'Fuschia': '-fuschia-',
    'Mint': '-mint-',
    'Sunshine': '-sunshine-',
    'Turqouse': '-turquoise-',
    'Neon Green': '-safetygreen-',
    'Orange': '-orange-',
    'White': '-WHT-',
    'Unicorn': '-UNI-',
    'Floral': '-FLW-'
  };

  // Set default selected swatch based on current product image
  $(".product-swatches").each(function () {
    const $swatchContainer = $(this);
    const $card = $swatchContainer.closest(".card-wrapper");
    const $productImage = $card.find(".card__media img").first();

    // Always check and correct the selection based on current image
    if ($productImage.length) {
      const currentImageSrc = $productImage.attr("src") || "";

      if (currentImageSrc) {
        // Find which color pattern matches the current image
        let matchedColorName = null;

        // Try to extract the actual filename from the Shopify CDN URL
        // Shopify URLs look like: https://cdn.shopify.com/.../.../filename_100x.jpg
        const urlParts = currentImageSrc.split('/');
        const filenameWithSize = urlParts[urlParts.length - 1]; // e.g., "AJ-BLK-S-01_400x400.jpg"
        const filename = filenameWithSize.split('_')[0]; // Remove size suffix: "AJ-BLK-S-01.jpg"

        // Check both the full URL and the extracted filename
        for (const [colorName, colorPattern] of Object.entries(colorMapping)) {
          const patternLower = colorPattern.toLowerCase();
          const matchInUrl = currentImageSrc.toLowerCase().includes(patternLower);
          const matchInFilename = filename.toLowerCase().includes(patternLower);

          if (matchInUrl || matchInFilename) {
            matchedColorName = colorName;
            break;
          }
        }

        // If we found a matching color, select that swatch
        if (matchedColorName) {
          const $matchingSwatch = $swatchContainer.find(`.product-swatches__link[data-color-name="${matchedColorName}"]`);

          if ($matchingSwatch.length) {
            // Remove all selected classes first
            $swatchContainer.find(".product-swatches__link").removeClass("product-swatches__link--selected");
            // Add selected class to the correct swatch
            $matchingSwatch.addClass("product-swatches__link--selected");
          } else {
            // Fallback to first swatch if no match found
            $swatchContainer.find(".product-swatches__link").removeClass("product-swatches__link--selected");
            $swatchContainer.find(".product-swatches__link").first().addClass("product-swatches__link--selected");
          }
        } else {
          // No color pattern matched, default to first swatch
          $swatchContainer.find(".product-swatches__link").removeClass("product-swatches__link--selected");
          $swatchContainer.find(".product-swatches__link").first().addClass("product-swatches__link--selected");
        }
      } else {
        // No image src, default to first swatch
        $swatchContainer.find(".product-swatches__link").removeClass("product-swatches__link--selected");
        $swatchContainer.find(".product-swatches__link").first().addClass("product-swatches__link--selected");
      }
    }
  });

  // Handle swatch click to change product image - USE EVENT DELEGATION for dynamically loaded products
  $(document).off("click", ".product-swatches__link").on("click", ".product-swatches__link", function (e) {
    e.preventDefault();

    const $swatch = $(this);
    const colorName = $swatch.attr("data-color-name");

    // Remove selected class from siblings
    $swatch.closest(".product-swatches").find(".product-swatches__link").removeClass("product-swatches__link--selected");

    // Add selected class to clicked swatch
    $swatch.addClass("product-swatches__link--selected");

    // Find the product card and get product media data
    const $card = $swatch.closest(".card-wrapper");
    const $productImage = $card.find(".card__media img").first();
    const productMediaData = $card.find(".product-media-data");

    if ($productImage.length && productMediaData.length && colorName) {
      try {
        const mediaData = JSON.parse(productMediaData.text());

        const colorPattern = colorMapping[colorName];

        if (colorPattern) {
          // Find media with matching color pattern
          const matchingMedia = mediaData.media.find(media =>
            media.src && media.src.toLowerCase().includes(colorPattern.toLowerCase())
          );

          if (matchingMedia) {
            // Update the main product image
            $productImage.attr("src", matchingMedia.src);
            $productImage.attr("alt", matchingMedia.alt || colorName);

            // Update srcset if exists
            if (matchingMedia.srcset) {
              $productImage.attr("srcset", matchingMedia.srcset);
            }
          }
        }
      } catch (error) {
        console.error("Error parsing product media data:", error);
      }
    }
  });
}
function discountSubmitHandle() {
  let discountCode = $(".cartDiscountInput").val();
  if (discountCode) {
    const submitButton = $(".cartDiscountSubmit");
    const discountInput = $(".cartDiscountInput");
    submitButton.addClass("loading").attr("disabled", true);

    // Remove any existing error message
    $(".cartDiscountError").remove();

    fetch("/checkout?discount=" + encodeURIComponent(discountCode))
      .then(() => {
        return fetch(`${routes.cart_url}?section_id=cart-drawer`);
      })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.cart_discounts_codes'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }

        // Check if discount was applied by checking if any discount codes are shown
        const hasDiscountCodes = $(".cart_discounts_codes li").length > 0;

        if (hasDiscountCodes) {
          // Clear the input after successful application
          discountInput.val('');
        } else {
          // Show error message if no discount was applied
          const errorMessage = '<div class="cartDiscountError">Enter a valid discount code or gift card</div>';
          $(".cartDiscountWrapper").after(errorMessage);
        }

        // Re-bind remove discount handlers
        $(".remove-discount").off("click", discountRemoveHandle);
        $(".remove-discount").on("click", discountRemoveHandle);
      })
      .catch((error) => {
        console.error('Discount code error:', error);
      })
      .finally(() => {
        submitButton.removeClass("loading").attr("disabled", false);
      });
  }
}

function discountRemoveHandle() {
  const discountCode = $(this).data("code");
  if (discountCode) {
    const removeButton = $(this);
    const submitButton = $(".cartDiscountSubmit");
    removeButton.addClass("loading");
    submitButton.addClass("loading").attr("disabled", true);

    // Remove discount by calling checkout with empty discount
    fetch("/checkout?discount=")
      .then(() => {
        return fetch(`${routes.cart_url}?section_id=cart-drawer`);
      })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.cart_discounts_codes'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
        // Re-bind remove discount handlers
        $(".remove-discount").off("click", discountRemoveHandle);
        $(".remove-discount").on("click", discountRemoveHandle);
      })
      .catch((error) => {
        console.error('Discount remove error:', error);
      })
      .finally(() => {
        removeButton.removeClass("loading");
        submitButton.removeClass("loading").attr("disabled", false);
      });
  }
}

// Recently Viewed Products Tracking
function trackRecentlyViewed() {
  // Only track on product pages
  if (window.location.pathname.includes('/products/')) {
    const productHandle = window.location.pathname.split('/products/')[1];
    if (productHandle) {
      addToRecentlyViewed(productHandle);
    }
  }
}

function addToRecentlyViewed(productHandle) {
  const recentlyViewed = getRecentlyViewed();

  // Remove if already exists (to move to front)
  const filtered = recentlyViewed.filter(handle => handle !== productHandle);

  // Add to front
  filtered.unshift(productHandle);

  // Keep only last 10 products
  const limited = filtered.slice(0, 10);

  // Save back to localStorage
  localStorage.setItem('recentlyViewed', JSON.stringify(limited));
}


function getRecentlyViewed() {
  try {
    const stored = localStorage.getItem('recentlyViewed');
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    return [];
  }
}


// Function to load recently viewed products in cart drawer
function loadRecentlyViewedProducts() {
  const recentlyViewed = getRecentlyViewed();

  if (recentlyViewed.length > 0) {
    // Fetch each product individually
    const promises = recentlyViewed.slice(0, 10).map(handle => {
      return fetch(`/products/${handle}.js`)
        .then(response => response.ok ? response.json() : null)
        .catch(() => null);
    });

    Promise.all(promises)
      .then(products => {
        const validProducts = products.filter(p => p !== null);

        if (validProducts.length > 0) {
          displayRecentlyViewedProducts(validProducts, 'Recently viewed');
        } else {
          loadCollectionFallback();
        }
      })
      .catch(() => {
        loadCollectionFallback();
      });
  } else {
    loadCollectionFallback();
  }
}

// Function to load product recommendations as fallback
function loadProductRecommendations() {
  // If we're on a product page, use that product for recommendations
  if (window.location.pathname.includes('/products/')) {
    const productHandle = window.location.pathname.split('/products/')[1];
    // We'll need to get the product ID from the handle
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        loadRecommendationsForProduct(product.id);
      })
      .catch(() => {
        // Fallback to default product recommendations
        loadDefaultProductRecommendations();
      });
  } else {
    // Not on a product page, use default product for recommendations
    loadDefaultProductRecommendations();
  }
}

function loadDefaultProductRecommendations() {
  // Default product ID for recommendations when not on a product page
  const defaultProductId = '4831811928149';

  // Use the configured default product for recommendations
  loadRecommendationsForProduct(defaultProductId);
}

function loadRecommendationsForProduct(productId) {
  const recommendationUrl = `/recommendations/products.json?product_id=${productId}&limit=10`;

  fetch(recommendationUrl)
    .then(response => response.json())
    .then(data => {
      if (data.products && data.products.length > 0) {
        displayRecentlyViewedProducts(data.products, 'Explore products');
      } else {
        loadFeaturedProducts();
      }
    })
    .catch(() => {
      loadFeaturedProducts();
    });
}

function loadFeaturedProducts() {
  // Fallback to getting some featured products
  fetch('/products.json?limit=10&sort_by=best-selling')
    .then(response => response.json())
    .then(data => {
      if (data.products && data.products.length > 0) {
        displayRecentlyViewedProducts(data.products, 'Explore products');
      }
    })
    .catch(error => {
      console.log('Error loading featured products:', error);
    });
}

// Function to load collection-based fallback (replaces product recommendations)
function loadCollectionFallback() {
  // Get the same logic as continue shopping button
  const cookieValue = getCookie('currentSizeType');
  let collectionHandle = 'adults-bestsellers'; // default to adults-bestsellers

  if (cookieValue === 'kids') {
    collectionHandle = 'kids-bestsellers'; // kids users see kids products
  } else if (cookieValue === 'adults') {
    collectionHandle = 'adults-bestsellers'; // adults users see adults products
  }

  console.log('Loading collection fallback for:', collectionHandle);

  // Fetch products from the appropriate collection
  fetch(`/collections/${collectionHandle}/products.json?limit=10&sort_by=best-selling`)
    .then(response => response.json())
    .then(data => {
      console.log('Collection API response:', data);
      if (data.products && data.products.length > 0) {
        console.log('First product from collection:', data.products[0]);
        const title = cookieValue === 'kids' ? 'Explore kids products' : 'Explore adults products';
        displayRecentlyViewedProducts(data.products, title);
      } else {
        loadFeaturedProducts();
      }
    })
    .catch(error => {
      console.error('Error loading collection products:', error);
      loadFeaturedProducts();
    });
}

// Helper function to get cookie value (reused from cart drawer logic)
function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function displayRecentlyViewedProducts(products, title = 'Recently viewed') {
  const slider = document.querySelector('#Slider-cart-drawer-recommendations');
  const section = document.getElementById('recently-viewed-section');
  const titleElement = section?.querySelector('.cart-drawer__collection-title');

  if (!slider || !section) return;

  // Update the title
  if (titleElement) {
    titleElement.textContent = title;
  }

  // Clear existing content
  slider.innerHTML = '';

  if (products.length > 0) {
    products.forEach((product, index) => {
      const productElement = createProductCard(product, index);
      slider.appendChild(productElement);
    });

    // Add autoplay and speed attributes
    slider.setAttribute('data-autoplay', 'true');
    slider.setAttribute('data-speed', '5');

    // Show the section
    section.style.display = 'block';

    // Initialize the slider after adding products
    // Use a slightly longer timeout to ensure DOM is fully updated
    setTimeout(() => {
      initializeSlider();
      // Re-initialize swatches for the newly added product cards
      initProductCardSwatches();

      // Load Judge.me star widgets using cache server
      const productIds = products.map(p => p.id).join(',');
      const shopDomain = 'rubies-active-wear.myshopify.com'; // Use Shopify domain, not custom domain
      const publicToken = 'DY-VLRm-mQv60BK19pxpvZI9S_k';
      const apiUrl = `https://cache.judge.me/widgets/shopify/${shopDomain}?public_token=${publicToken}&preview_badge_product_ids=${productIds}`;

      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          console.log('Judge.me badges loaded successfully');

          // Insert badge HTML for each product using Shopify star structure
          if (data.preview_badges) {
            products.forEach((product) => {
              const productId = String(product.id);
              const badgeHtml = data.preview_badges[productId];

              if (badgeHtml) {
                // Parse the badge HTML to extract rating data
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = badgeHtml;
                const badgeElement = tempDiv.querySelector('.jdgm-prev-badge');

                if (badgeElement) {
                  const averageRating = parseFloat(badgeElement.getAttribute('data-average-rating')) || 0;
                  const numberOfReviews = parseInt(badgeElement.getAttribute('data-number-of-reviews')) || 0;

                  // Only show if there are reviews
                  if (numberOfReviews > 0) {
                    // Calculate rating decimal for half stars (matching card-product.liquid logic)
                    const ratingFloor = Math.floor(averageRating);
                    const decimal = averageRating % 1;
                    let ratingDecimal = 0;
                    if (decimal >= 0.3 && decimal <= 0.7) {
                      ratingDecimal = 0.5;
                    } else if (decimal > 0.7) {
                      ratingDecimal = 1;
                    }

                    // Find the widget for this product
                    const widget = document.querySelector(`#Slider-cart-drawer-recommendations .jdgm-widget[data-id="${productId}"]`);

                    if (widget) {
                      // Create Shopify-style rating HTML
                      widget.innerHTML = `
                        <div class="rating" role="img" aria-label="${averageRating} star rating based on ${numberOfReviews} reviews">
                          <span
                            aria-hidden="true"
                            class="rating-star"
                            style="--rating: ${ratingFloor}; --rating-max: 5; --rating-decimal: ${ratingDecimal};"
                          ></span>
                        </div>
                        <p class="rating-text caption">
                          <span aria-hidden="true">
                            ${averageRating} / 5
                          </span>
                        </p>
                        <p class="rating-count caption">
                          <span aria-hidden="true">${numberOfReviews} ${numberOfReviews === 1 ? 'review' : 'reviews'}</span>
                          <span class="visually-hidden">
                            ${numberOfReviews} total reviews
                          </span>
                        </p>
                      `;
                      widget.style.display = 'block';
                    }
                  }
                }
              }
            });
          }
        })
        .catch(error => {
          console.error('Error fetching Judge.me badges:', error);
        });
    }, 200);
  } else {
    // Hide the section if no products
    section.style.display = 'none';
  }
}

function createProductCard(product, index) {
  const li = document.createElement('li');
  li.id = `Slide-cart-drawer-recommendations-${index + 1}`;
  li.className = 'grid__item';

  // Get the first available variant
  const variant = product.variants ? product.variants.find(v => v.available) || product.variants[0] : null;

  // Handle pricing - detect if this is from individual product API or collection API
  let price, compareAtPrice;
  const isIndividualProductAPI = product.variants && product.variants[0] && typeof product.variants[0].price === 'number' && product.variants[0].price > 1000;

  if (variant) {
    if (isIndividualProductAPI) {
      // Individual product API - prices are in cents, divide by 100
      price = variant.price ? (variant.price / 100).toFixed(2) : '0.00';
      compareAtPrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;
    } else {
      // Collection API - prices are already in dollars
      price = variant.price ? parseFloat(variant.price).toFixed(2) : '0.00';
      compareAtPrice = variant.compare_at_price ? parseFloat(variant.compare_at_price).toFixed(2) : null;
    }
  } else {
    // Fallback for collection API structure
    price = product.price ? parseFloat(product.price).toFixed(2) : '0.00';
    compareAtPrice = product.compare_at_price ? parseFloat(product.compare_at_price).toFixed(2) : null;
  }

  // Handle images - detect API type and handle accordingly
  let imageUrl, imageAlt;

  if (isIndividualProductAPI) {
    // Individual product API - images are direct URLs
    if (product.images && product.images.length > 0) {
      imageUrl = product.images[0];
      imageAlt = product.title;
    } else if (product.featured_image) {
      imageUrl = product.featured_image;
      imageAlt = product.title;
    } else {
      imageUrl = '/no-image.svg';
      imageAlt = product.title;
    }
  } else {
    // Collection API - images are objects with properties
    if (product.images && product.images.length > 0) {
      const imageObj = product.images[0];

      if (imageObj.src) {
        imageUrl = imageObj.src;
      } else if (imageObj.url) {
        imageUrl = imageObj.url;
      } else {
        // Fallback: construct URL using shop domain
        const imageId = imageObj.id;
        const shopDomain = window.location.hostname;
        imageUrl = `https://${shopDomain}/products/${imageId}.jpg`;
      }
      imageAlt = product.title;
    } else if (product.featured_image) {
      imageUrl = product.featured_image;
      imageAlt = product.title;
    } else {
      imageUrl = '/no-image.svg';
      imageAlt = product.title;
    }
  }

  // Format price with proper currency (detect currency from shop settings)
  const formatPrice = (priceValue) => {
    // Try to get currency from various sources
    let currency = 'CAD'; // default
    let locale = 'en-CA'; // default

    // Check for currency in Shopify global object
    if (window.Shopify?.currency?.active) {
      currency = window.Shopify.currency.active;
    }
    // Check for currency in theme settings or other global variables
    else if (window.theme?.currency) {
      currency = window.theme.currency;
    }
    // Check for currency in the product data itself
    else if (product.variants && product.variants[0] && product.variants[0].price) {
      // Try to detect currency from price format or other indicators
      currency = 'CAD'; // fallback to CAD for now
    }

    // Set locale based on currency
    if (currency === 'USD') {
      locale = 'en-US';
    } else if (currency === 'EUR') {
      locale = 'en-EU';
    } else if (currency === 'GBP') {
      locale = 'en-GB';
    }

    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(priceValue);

    // Add currency code after price if not USD
    const finalPrice = currency !== 'USD' ? `${formatted} ${currency}` : formatted;

    return finalPrice;
  };

  // Generate swatches HTML (matching product-card-color-swatches.liquid)
  const generateSwatches = () => {
    if (!product.options || !product.variants) return '';

    // Find the color option
    const colorOption = product.options.find(opt =>
      opt.name && opt.name.toLowerCase() === 'color'
    );

    if (!colorOption || !colorOption.values || colorOption.values.length === 0) return '';

    const swatchesHtml = colorOption.values.map((colorValue, idx) => {
      // Convert color name to handle format (lowercase, replace spaces with hyphens)
      const colorHandle = colorValue.toLowerCase().replace(/\s+/g, '-');

      // Generate swatch image URLs using Shopify's asset format
      const baseUrl = `//rubyshines.com/cdn/shop/t/370/assets/`;
      const swatchImageUrl1x = `${baseUrl}${colorHandle}.png`;
      const swatchImageUrl20x = `${baseUrl}${colorHandle}_20x.png`;
      const swatchImageUrl40x = `${baseUrl}${colorHandle}_40x.png`;
      const swatchImageUrl80x = `${baseUrl}${colorHandle}_80x.png`;

      // Get background color (fallback to color name as CSS color)
      const backgroundColor = colorHandle.replace(/-/g, '');

      // Find variant with this color for image data
      const colorVariant = product.variants.find(v => {
        if (v.option1 === colorValue) return true;
        if (v.option2 === colorValue) return true;
        if (v.option3 === colorValue) return true;
        return false;
      });

      const isSelected = idx === 0; // First swatch is selected by default
      const hideClass = idx >= 3 ? ' showelements' : '';

      return `
        <li class="product-swatches__li${hideClass}">
          <a
            href="javascript:;"
            class="product-swatches__link ${isSelected ? 'product-swatches__link--selected' : ''}"
            aria-label="${colorValue}"
            title="${colorValue}"
            data-color-name="${colorValue}"
          >
            <div
              loading="lazy"
              class="product-swatches__color lazyload"
              data-bgset="${swatchImageUrl20x} 20w, ${swatchImageUrl40x} 40w, ${swatchImageUrl80x} 80w"
              style="background-color: ${backgroundColor}; background-image: url(${swatchImageUrl1x});"
            >
              <span class="product-swatches__label">${colorValue}</span>
            </div>
          </a>
        </li>
      `;
    }).join('');

    return `<ul class="product-swatches product-swatches--circle">${swatchesHtml}</ul>`;
  };

  const hasSale = compareAtPrice && parseFloat(compareAtPrice) > parseFloat(price);
  const swatchesHtml = generateSwatches();

  // Create the card structure matching card-product.liquid
  li.innerHTML = `
    <div class="card-wrapper product-card-wrapper underline-links-hover" data-product-handle="${product.handle}">
      <script type="application/json" class="product-media-data">
        {
          "media": ${JSON.stringify((product.images || []).map(img => ({
            id: img.id || '',
            src: typeof img === 'string' ? img : img.src || img.url || img,
            alt: product.title
          })))}
        }
      </script>
      <div class="card card--standard card--media" style="--ratio-percent: 100%;">
        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
          <div class="card__media" data-product-id="${product.id || ''}">
            <div class="media media--transparent media--hover-effect">
              <a href="/products/${product.handle}">
                <img src="${imageUrl}" alt="${imageAlt}" loading="lazy" width="400" height="auto" class="motion-reduce">
              </a>
            </div>
          </div>
        </div>
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading h5">
              <a href="/products/${product.handle}" class="full-unstyled-link">
                ${product.title}
              </a>
            </h3>
            <div class="card-information">
              <div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}"></div>
              <div class="productCardSwatchPrice">
                ${swatchesHtml}
                <div class="price ${hasSale ? 'price--on-sale' : ''}">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span class="price-item price-item--regular">
                        ${formatPrice(parseFloat(price))}
                      </span>
                    </div>
                    <div class="price__sale">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span>
                        <s class="price-item price-item--regular">
                          ${formatPrice(parseFloat(compareAtPrice))}
                        </s>
                      </span>
                      <span class="visually-hidden visually-hidden--inline">Sale price</span>
                      <span class="price-item price-item--sale price-item--last">
                        ${formatPrice(parseFloat(price))}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  return li;
}

function initializeSlider() {
  const slideshowComponent = document.querySelector('#recently-viewed-section slideshow-component-2');
  if (!slideshowComponent) return;

  const prevButton = slideshowComponent.querySelector('.slider-button--prev');
  const nextButton = slideshowComponent.querySelector('.slider-button--next');
  const slider = slideshowComponent.querySelector('[id^="Slider-"]');
  const desktopColumns = 2;
  const mobileColumns = 2;

  if (!prevButton || !nextButton || !slider) return;

  function updateStep() {
    const isMobile = window.innerWidth < 750;
    const step = isMobile ? mobileColumns : desktopColumns;
    if (prevButton) prevButton.setAttribute('data-step', step);
    if (nextButton) nextButton.setAttribute('data-step', step);
  }

  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateStep, 100);
  });

  updateStep();

  // Force re-initialization of the slideshow component
  // This is critical because products are loaded after the component was created
  if (slideshowComponent.slider && typeof slideshowComponent.initPages === 'function') {
    slideshowComponent.slider = slider;
    slideshowComponent.sliderItems = slideshowComponent.querySelectorAll('[id^="Slide-"]');
    slideshowComponent.initPages();

    // Set up autoplay if the slider has the data attribute
    if (slider.getAttribute('data-autoplay') === 'true' && typeof slideshowComponent.setAutoPlay === 'function') {
      slideshowComponent.setAutoPlay();
    }
  }
}